<div class="sign-control">
    <h4 mat-dialog-title>{{ 'sign_control.title' | translate }}</h4>
    <div mat-dialog-content>
        <p class="sign-control-description">{{ data.description }}</p>

        <mat-form-field floatLabel="always" appearance="outline" class="sign-control-select">
            <mat-label>{{ 'reports.crypto.select_certificate' | translate }}</mat-label>
            <mat-select [(ngModel)]="thumbprint" [disabled]="signing">
                <mat-option *ngFor="let cert of certificates" [value]="cert.thumbprint">
                    {{ cert.name + ('reports.crypto.actual_to' | translate) + (cert.validTo | date: 'dd.MM.yyyy') + ')' }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div class="sign-control-spinner">
            <mat-spinner *ngIf="loading || signing" diameter="32"></mat-spinner>
        </div>
        <p *ngIf="signing" class="sign-control-hint">{{ 'sign_control.enter_pin' | translate }}</p>
        <p *ngIf="errorKey" class="sign-control-error">{{ 'sign_control.errors.' + errorKey | translate }}</p>
        <p *ngIf="errorDetail && errorDetail !== errorKey" class="sign-control-detail">{{ errorDetail }}</p>
    </div>
    <mat-dialog-actions class="sign-control-actions">
        <button mat-button (click)="loadCertificates(true)" [disabled]="loading || signing">
            {{ 'sign_control.refresh' | translate }}
        </button>
        <span class="sign-control-spacer"></span>
        <button mat-flat-button color="warn" (click)="cancel()">
            {{ 'sign_control.cancel' | translate }}
        </button>
        <button mat-flat-button color="primary" (click)="sign()" [disabled]="!thumbprint || loading || signing">
            {{ 'sign_control.sign_and_execute' | translate }}
        </button>
    </mat-dialog-actions>
</div>
